// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iM","advertCardFooter__row":"c-a_iN","advertCardFooter__name":"c-a_iO","advertCardFooter__price":"c-a_iP","advertCardFooter__age":"c-a_iQ"};